<div class="wrapper">
	<div class="new">NEW</div>
	<div class="info">Search for a certain student and see previous passes, get quick stats, check permissions, and more...</div>
	<div class="buttons">
		<app-gradient-button
			[gradient]="'#70819f, #70819f'"
			[buttonLink]="'https://www.smartpass.app/studentsearch'"
			[text]="'Learn more'"
			(buttonClick)="close.emit(false)"></app-gradient-button>
		<app-gradient-button style="margin-left: 10px" (buttonClick)="tryButton.emit(false)">Try it!</app-gradient-button>
	</div>
</div>
